import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/index/lightPoint.png';
import _imports_1 from '@/assets/img/index/LLMOps.svg';
import _imports_2 from '@/assets/img/index/agentControl.svg';
import _imports_3 from '@/assets/img/index/flexibleExtensible.svg';
const _withScopeId = n => (_pushScopeId("data-v-406955be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "back-agent"
};
const _hoisted_2 = {
  alt: ""
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-page"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "专为企业级大模型系统设计的全方位解决方案")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, " 提供智能体管理和模型管理的一体化平台，为企业级用户提供了便捷、安全的智能体管理和模型管理服务 ")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-top"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "助力用户构建高效、稳定的AI系统")])])], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "con-detail"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 模型管理（LLMOps） ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 智能体管理 ")]), /*#__PURE__*/_createElementVNode("p", {
  class: "detail-cell"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 灵活可扩展 ")])], -1));
import agentCom from './agentCom.vue';
import { ref } from 'vue';
export default {
  __name: 'aigcCom',
  setup(__props, {
    expose: __expose
  }) {
    let pageActive = ref(false);
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pageActive) ? 'code-agent active' : 'code-agent')
      }, [_createVNode(agentCom, {
        "flex-revert": true,
        showBotton: true,
        title: '云起AI安全大脑',
        pageUrl: '/aigcProduct.html'
      }, {
        left: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [[_directive_lazy, require('@/assets/img/index/aigcComInst.svg')]])])]),
        right: _withCtx(() => [_hoisted_3]),
        bottom: _withCtx(() => [_hoisted_4]),
        _: 1
      })], 2);
    };
  }
};